import styled from "styled-components";

export const Level = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

export const LevelContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  text-align: center;
`;

export const LevelTitle = styled.div`
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: var(--text-dim);
  text-transform: uppercase;
  letter-spacing: 6px;

  &::before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 1px;
    background: var(--text-dim);
    vertical-align: middle;
    margin-right: 12px;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 24px;
    height: 1px;
    background: var(--text-dim);
    vertical-align: middle;
    margin-left: 12px;
  }
`;

export const LevelButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;

export const Hint = styled.div`
  color: var(--text-dim);
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.6;

  kbd {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 2px 8px;
    margin: 0 4px;
    color: var(--accent);
    font-family: inherit;
  }
`;

export const LevelButton = styled.button`
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--panel);
  color: var(--text);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 18px 32px;
  min-width: 140px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);

  &:hover {
    border-color: var(--accent);
    color: var(--accent);
    transform: translateY(-3px);
    box-shadow:
      0 8px 20px rgba(0, 0, 0, 0.5),
      0 0 24px var(--accent-glow),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }

  &:active {
    transform: translateY(-1px);
  }
`;
